import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { BackgroundOperationState } from '../../state-stores/background-operation.state';
import { BackgroundOperationRunner } from '../../services/background-operation-runner-service/background-operation-runner.service';

/**
 * Always-mounted (app shell level) modal that shows the result of a
 * BackgroundOperationState-driven operation, regardless of which page the
 * user is on when it completes.
 */
@Component({
  selector: 'app-background-operation-result-modal',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './background-operation-result-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class BackgroundOperationResultModalComponent {
  constructor(
    protected readonly backgroundOperationState: BackgroundOperationState,
    private readonly backgroundOperationRunner: BackgroundOperationRunner,
  ) {}

  close(): void {
    this.backgroundOperationRunner.dismissResult();
  }
}
